(function () {
  'use strict';

  /* ====== CSS ====== */
  var st = document.createElement('style');
  st.textContent =
    '.isp-backdrop{position:fixed;inset:0;z-index:400;background:rgba(0,0,0,.01)}' +
    '.isp-picker{position:absolute;left:0;right:0;bottom:calc(100% + 8px);z-index:401;' +
    'background:#fff;background:rgb(var(--color-background,255,255,255));' +
    'border:1.5px solid rgba(0,0,0,.12);border-radius:10px;' +
    'padding:14px 16px 16px;box-shadow:0 -6px 28px rgba(0,0,0,.14);}' +
    '.isp-picker.isp-below{bottom:auto;top:calc(100% + 8px);box-shadow:0 6px 28px rgba(0,0,0,.14);}' +
    '.isp-lbl{margin:0 0 8px;font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;' +
    'color:rgb(var(--color-foreground,0,0,0))}' +
    '.isp-row{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:12px}' +
    '.isp-opt{padding:6px 12px;border:1.5px solid rgba(0,0,0,.2);border-radius:6px;' +
    'font-size:13px;cursor:pointer;background:transparent;font-family:inherit;' +
    'color:rgb(var(--color-foreground,0,0,0));transition:all .15s}' +
    '.isp-opt:hover:not(:disabled){border-color:rgb(var(--color-foreground,0,0,0))}' +
    '.isp-opt.sel{background:rgb(var(--color-foreground,0,0,0));color:rgb(var(--color-background,255,255,255));border-color:rgb(var(--color-foreground,0,0,0))}' +
    '.isp-opt:disabled{opacity:.35;text-decoration:line-through;cursor:not-allowed}' +
    '.isp-go{width:100%;padding:10px;font-size:13px;font-family:inherit;cursor:pointer;border-radius:6px}' +
    '.isp-go:disabled{opacity:.4;cursor:not-allowed}';
  document.head.appendChild(st);

  var BD = null, PK = null;

  function close() {
    if (PK) { PK.remove(); PK = null; }
    if (BD) { BD.remove(); BD = null; }
  }

  /* ====== intercept CLICK in capture — catches both modal-opener and product-form paths ====== */
  document.addEventListener('click', function (e) {
    /* match any quick-add button */
    var btn = e.target.closest('.quick-add__submit, .quick-add [name="add"]');
    if (!btn) return;

    /* only if inside the complementary / quick-add area */
    var qa = btn.closest('.quick-add, .complementary-products');
    if (!qa) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    close();

    /* find product URL */
    var url = btn.dataset.productUrl;
    if (!url) {
      var card = btn.closest('.card-wrapper, .product-card-wrapper, .complementary-slide, .grid__item, li');
      var a = card && card.querySelector('a[href*="/products/"]');
      url = a ? a.getAttribute('href') : null;
    }
    if (!url) return;

    var handle = url.split('/products/')[1];
    if (!handle) return;
    handle = handle.split('?')[0].split('#')[0];

    /* loading */
    var lbl = btn.querySelector('.main-atc__label__text');
    var orig = lbl ? lbl.textContent : btn.textContent;
    btn.disabled = true;
    if (lbl) lbl.textContent = '...';

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        btn.disabled = false;
        if (lbl) lbl.textContent = orig;

        if (!p.variants || p.variants.length === 0) return;
        if (p.variants.length === 1) { add(p.variants[0].id, btn); return; }

        buildPicker(p, btn, qa);
      })
      .catch(function () {
        btn.disabled = false;
        if (lbl) lbl.textContent = orig;
      });

  }, true);

  /* ====== also block submit event as safety net ====== */
  document.addEventListener('submit', function (e) {
    if (!e.target.closest('.quick-add, .complementary-products')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);

  /* ====== build size picker ====== */
  function buildPicker(product, triggerBtn, qa) {
    var wrap = triggerBtn.closest('.quick-add') || qa;
    if (!wrap) return;
    wrap.style.position = 'relative';

    var pk = document.createElement('div');
    pk.className = 'isp-picker';
    if (wrap.getBoundingClientRect().top < 280) pk.classList.add('isp-below');

    var goBtn;

    product.options.forEach(function (optName, i) {
      var pos = i + 1;
      var seen = [], vals = [];
      product.variants.forEach(function (v) {
        var x = v['option' + pos];
        if (seen.indexOf(x) < 0) { seen.push(x); vals.push(x); }
      });

      var lbl = document.createElement('p');
      lbl.className = 'isp-lbl';
      lbl.textContent = optName;
      pk.appendChild(lbl);

      var row = document.createElement('div');
      row.className = 'isp-row';

      vals.forEach(function (val) {
        var avail = product.variants.some(function (v) {
          return v['option' + pos] === val && v.available;
        });
        var ob = document.createElement('button');
        ob.type = 'button';
        ob.className = 'isp-opt' + (avail ? '' : '');
        ob.textContent = val;
        ob.disabled = !avail;
        ob.dataset.pos = pos;
        ob.dataset.val = val;
        ob.addEventListener('click', function () {
          row.querySelectorAll('.isp-opt').forEach(function (x) { x.classList.remove('sel'); });
          ob.classList.add('sel');
          resolve(pk, product, goBtn);
        });
        row.appendChild(ob);
      });
      pk.appendChild(row);
    });

    goBtn = document.createElement('button');
    goBtn.type = 'button';
    goBtn.className = 'button button--full-width isp-go';
    goBtn.disabled = true;
    goBtn.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Adicionar ao carrinho';
    goBtn.addEventListener('click', function () {
      var vid = pk.dataset.vid;
      if (!vid || goBtn.disabled) return;
      add(+vid, triggerBtn, pk);
    });
    pk.appendChild(goBtn);

    wrap.appendChild(pk);
    PK = pk;

    var bd = document.createElement('div');
    bd.className = 'isp-backdrop';
    bd.addEventListener('click', close);
    document.body.appendChild(bd);
    BD = bd;
  }

  function resolve(pk, product, goBtn) {
    var sel = {};
    pk.querySelectorAll('.isp-opt.sel').forEach(function (b) { sel[b.dataset.pos] = b.dataset.val; });
    if (Object.keys(sel).length < product.options.length) {
      pk.dataset.vid = ''; goBtn.disabled = true; return;
    }
    var m = product.variants.find(function (v) {
      return Object.keys(sel).every(function (p) { return v['option' + p] === sel[p]; });
    });
    pk.dataset.vid = m ? m.id : '';
    goBtn.disabled = !m || !m.available;
  }

  /* ====== add to cart ====== */
  function add(variantId, triggerBtn, pk) {
    var gb = pk ? pk.querySelector('.isp-go') : null;
    if (gb) { gb.disabled = true; gb.textContent = '...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      close();

      ['cart:refresh','cart:added'].forEach(function (ev) {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      });

      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (typeof drawer.renderContents === 'function') drawer.renderContents({items:[]});
        else if (typeof drawer.open === 'function') drawer.open(triggerBtn);
      }

      var lbl = triggerBtn.querySelector('.main-atc__label__text');
      if (lbl) { var o = lbl.textContent; lbl.textContent = '\u2713'; setTimeout(function(){lbl.textContent=o;},1800); }

      fetch('/?sections=cart-icon-bubble').then(function(r){return r.json();}).then(function(s){
        var h=s['cart-icon-bubble']; if(!h) return;
        var t=document.createElement('div'); t.innerHTML=h;
        var nb=t.querySelector('.cart-count-bubble'), ob=document.querySelector('.cart-count-bubble');
        if(nb&&ob) ob.outerHTML=nb.outerHTML;
      }).catch(function(){});
    })
    .catch(function () {
      if (gb) { gb.disabled=false; gb.textContent=(window.variantStrings&&window.variantStrings.addToCart)||'Adicionar ao carrinho'; }
    });
  }

})();
